module.exports = __webpack_public_path__ + "static/media/Scratching2.2515ba16.mp3";